// extracted by mini-css-extract-plugin
export default {"tabsList":"styles_tabsList__e7r9T","tab":"styles_tab__MiffY","activeTab":"styles_activeTab__b3kAA","tabPanel":"styles_tabPanel__J1Z4C"};